<template>
  <Stage>
    <section class="images">
      <img
        v-for="index in list"
        :src="getImageUrl(getArrow(index))"
        :key="index"
      />
    </section>

    <div class="footer">
      <Button
        @keydown="handleTrialResponse"
        exam
        :label="trialData.footer.leading_button.text"
        :keys="['z']"
        disableMouse
      />
      <Button
        @keydown="handleTrialResponse"
        exam
        :label="trialData.footer.trailing_button.text"
        :keys="['m']"
        disableMouse
      />
    </div>
  </Stage>
</template>

<script>
import essComponentProps from '@/mixins/essComponentProps'
import { Stage, Button } from '@neurotrack/web-shared-components'
import range from '@/util/range'

export default {
  name: 'image_series_5',
  components: { Stage, Button },
  mixins: [essComponentProps],
  methods: {
    getArrow(index) {
      return this.trialData.body[
        `${this[this.trial.trial_scoring_type][index]}_arrow`
      ].filename
    }
  },
  data() {
    return {
      list: range(0, 4, 1),
      incongruent_left: ['right', 'right', 'left', 'right', 'right'],
      incongruent_right: ['left', 'left', 'right', 'left', 'left'],
      congruent_right: ['right', 'right', 'right', 'right', 'right'],
      congruent_left: ['left', 'left', 'left', 'left', 'left']
    }
  }
}
</script>

<style scoped>
.images {
  display: grid;
  grid-auto-columns: 1fr;
  grid-gap: 1rem;
  grid-auto-flow: column;
  margin: 5rem 0;
  min-height: 63px;
}
.footer {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
}
.footer * {
  margin: 0 0.5rem;
}
img {
  width: 100px;
}
</style>
